import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const SortableDestinationRow = ({ index, moveDestination, children }) => {
  const rowRef = useRef(null);
  const dragHandleRef = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: "package-destination",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: "package-destination",
    hover(draggedItem) {
      if (draggedItem.index === index) return;
      moveDestination(draggedItem.index, index);
      draggedItem.index = index;
    },
  });

  drag(dragHandleRef);
  drop(rowRef);

  return (
    <div
      ref={rowRef}
      className={`flex items-stretch gap-2 transition-opacity ${
        isDragging ? "opacity-50" : "opacity-100"
      }`}
    >
      <button
        ref={dragHandleRef}
        type="button"
        className="flex w-8 shrink-0 cursor-grab items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-400 hover:border-gray-300 hover:text-gray-600 active:cursor-grabbing"
        aria-label={`Drag destination ${index + 1} to reorder`}
        title="Drag to reorder"
      >
        <i className="fi fi-rr-grip-dots-vertical"></i>
      </button>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
};

export default SortableDestinationRow;
